/**
 * このアプリのヘルプ。文書は隣の `content/<セクション>/<スラッグ>.md` に置く。
 *
 * glob はこのモジュールの位置から解決されるので、集めるのはここで行い、
 * 並びと引き当ては共通パッケージの `createHelpRegistry` に任せる。
 */

import {
  createHelpIcon,
  createHelpPage,
  createHelpRegistry,
  type HelpSectionTitle,
} from "visumo-data-agent-web-shared";

const rawFiles = import.meta.glob("./content/**/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

/**
 * セクションの表示名と並び。ここに無いディレクトリも、末尾にディレクトリ名の
 * まま出る。
 */
export const SECTION_TITLES: readonly HelpSectionTitle[] = Object.freeze([
  { key: "getting-started", title: "はじめに" },
  { key: "tenants", title: "会社" },
  { key: "semantics-fill", title: "属性の機械生成" },
  { key: "audit", title: "監査ログ" },
  { key: "account", title: "本人設定" },
]);

export const registry = createHelpRegistry({
  files: rawFiles,
  sectionTitles: SECTION_TITLES,
});

export const HelpIcon = createHelpIcon(registry);

/** 見出しの横に置くものは `pages/HelpPage.tsx` が `extra` で渡す */
export const HelpPage = createHelpPage(registry);
